import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"></path>
  </>,
  'Warning',
)
